import React from 'react'
import { Switch } from '@headlessui/react'
import { classNames } from 'lib/utils'

export default function Toggle({
    checked,
    onChange,
    iconLeft,
    iconRight,
}: {
    checked: boolean
    onChange: (checked: boolean) => void
    iconLeft?: React.ReactNode
    iconRight?: React.ReactNode
}) {
    return (
        <span className="flex items-center space-x-1.5">
            {iconLeft && (
                <span className={`${checked ? 'opacity-50' : 'opacity-80'} font-semibold transition-opacity`}>
                    {iconLeft}
                </span>
            )}
            <Switch
                checked={checked}
                onChange={onChange}
                className="group relative inline-flex h-2 w-8 flex-shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none"
            >
                <span className="sr-only">Use setting</span>
                <span
                    aria-hidden="true"
                    className="pointer-events-none absolute h-full w-full rounded-md bg-[#c4c4c4] dark:bg-[#5A5A5A]"
                />
                <span
                    aria-hidden="true"
                    className={classNames(
                        checked ? 'translate-x-5' : 'translate-x-0',
                        'pointer-events-none absolute left-0 inline-block h-4 w-4 transform rounded-full bg-[#0e0e0e] ring-0 transition-transform duration-200 ease-in-out dark:bg-[#999]'
                    )}
                />
            </Switch>
            {iconRight && (
                <span className={`${!checked ? 'opacity-50' : 'opacity-80'} font-semibold transition-opacity`}>
                    {iconRight}
                </span>
            )}
        </span>
    )
}
